<template>
  <v-app style="padding: 0px!important; direction: rtl;">
    <v-container fluid="fluid" class="full loginGrd">
      <br />
      <v-layout row-sm column child-flex-sm>
        <div>
          <div class="c1Intro">
            <div class="c2Intro">
              <img v-if="$root.device.isMobile" class="logo" src="../../static/yomanet.png" style="width: 100px; height: 100px;" />
              <img v-else class="logo" src="../../static/yomanet.png" />
            </div>
          </div>
        </div>
      </v-layout>
      <v-layout row-sm column child-flex-sm mt-2>
        <div></div>
        <div>
          <h4 style="color: #fff;">כניסה למערכת</h4>
        </div>
        <div></div>
      </v-layout>
      <v-layout style="margin: auto; width: 300px;">
        <v-flex xs12>
          <table style="width: 100%;">
            <tr>
              <td>
                <br />
                <span class="lblWhiteR" style="width: 80%;">אימייל</span>
                <v-icon class="text-xl-right lblWhiteR" style="width: 20%; float: left; text-align: left!important; display: block;" @click="clearUser">close</v-icon>
                <br />
                <input class="txtLogin" style="width: 100%;" type="text" v-model="username" @keyup="resetError" />
              </td>
            </tr>
            <tr>
              <td>
                <br />
                <span class="lblWhiteL" style="width: 80%;">סיסמה</span>
                <v-icon class="text-xl-right lblWhiteR" style="width: 20%;float: left; text-align: left!important; display: block;" @click="clearPassword">close</v-icon>
                <br />
                <input class="txtLogin" style="width: 100%;" type="password" v-model="password" @keyup="resetError" />
              </td>
            </tr>
            <tr>
              <td>
                <br />
                <div class="lnkBtn" @click="isPasswordReset=true">שכחתי סיסמה</div>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
      <v-layout column wrap align-center>
        <v-flex xs12 md12 class="my-3">
          <div style="width: 100%; padding: 10px;">
            <span v-if="$root.loginError" style="color: #c00000;">{{$root.loginError}}</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center style="margin: auto; width: 300px;">
        <v-flex xs6 style="padding: 20px;">
          <input type="button" style="float: left;" class="btnBrown" value="כניסה" @click="$root.login(username, password)" />
        </v-flex>
        <v-flex xs6 style="padding: 20px;">
          <input type="button" style="float: left;" class="btnBrown" value="הרשמה" @click="isRegister=true" />
        </v-flex>
      </v-layout>

      <v-snackbar :timeout="$root.alert.timeout" :top="$root.alert.isTop" v-model="$root.alert.isShow">{{ $root.alert.message }}</v-snackbar>
      <PopupRegister></PopupRegister>
      <PopupPasswordReset></PopupPasswordReset>
    </v-container>
  </v-app>
</template>
<script>
  import moment from 'moment';
  import { auth, db } from '../firebase';
  var usersRef = db.ref('Users');
  import PopupRegister from '../components/PopupRegister';
  import PopupPasswordReset from '../components/PopupPasswordReset';

  export default {
    name: 'login',
    components: { PopupRegister, PopupPasswordReset },
    data() {
      return {
        isPasswordReset: false,
        isRegister: false,
        username: '',
        password: '',
      }
    },
    created() {
      this.$ForceLog("Vue [login] is created ...");
    },
    ready() {
      this.$Log("Vue [login] is ready ...");
    },
    mounted() {
      this.$Log("Vue [login] is mounted ...");
      //this.username = "admin";
      //this.password = "123";

      if (this.$root.isLoginFromReset) {
        this.$root.isLoginFromReset = false;
        this.$root.alert.isShow = true;
      }
    },
    updated() {
      this.$Log("Vue [login] is updated ...");
    },
    methods: {
      resetError() {
        this.$root.loginError = "";
      },
      clearUser() {
        this.username = "";
      },
      clearPassword() {
        this.password = "";
      },
    }
  }

</script>
<style>
  .loginGrd {
    background: #F7941D;
  }

  .btnBrown {
    border-radius: 5px;
    border: 1px solid #3A2D01;
    background-color: #3A2D01;
    color: #fff;
    height: 40px;
    width: 100%;
    background-color: transparent;
    color: #3A2D01;
    border: 1px solid #3A2D01;
    border: 1px solid #fff;
    color: #fff;
  }

    .btnBrown:hover {
      /*background-color: #fff;*/
      color: #3A2D01;
      border: 1px solid #3A2D01;
    }

  .divCenter{
    width: 60%;
  }

  .divSide {
    width: 20%;
  }

  .lnkBtn {
    text-decoration: underline;
    float: left;
    color: #fff;
    cursor: pointer;
  }

    .lnkBtn:hover {
      color: #3A2D01;
    }

  .txtLogin {
    color: #3A2D01;
    border-bottom: solid 1px #fff;
    text-align: center;
  }

  select:focus, textarea:focus, input:focus {
    outline: none;
  }

  .logo {
    width: 200px;
  }

  .full {
    height: 100vh;
    width: 100vw;
  }

  .btn--round, .btn--round:after {
    border-radius: 15px;
  }

  .lblWhiteL {
    width: 100%;
    color: white;
    text-align: right;
    float: right;
  }

  .lblWhiteR {
    width: 100%;
    color: white;
    text-align: right;
    float: right;
  }

  

  .icon {
    -ms-flex-align: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    cursor: pointer;
  }

  .btn--round, .btn--round:after {
    border-radius: 5px;
  }

  .snack {
    width: 500px;
  }

  .snack__content{
    display: block;
    text-align: center!important;
    padding-top: 35px;
    height: 60px;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?063a3a0a